export const planDetails = [
    {
        id: 1,
        name: "BPL Card Holder",
        value: "BPL Card Holder",
        price: 0,
        deposit: 0,
        renewal_price: 0,
        book_status: "1",
        ebook_status: "1",
        library_status: "1",
        description: "BPL Card will have access as given below for free:",
        frequency: 3,
        slug: "test",
        deleted_at: null,
        created_at: "2024-02-21T10:17:19.000000Z",
        updated_at: "2024-03-01T10:36:07.000000Z",
        num_books_borrow: null
    },
    {
        id: 2,
        name: "Family Plan (4 Member)",
        value: "Family Plan (4 Member)",
        price: 1510,
        deposit: 0,
        renewal_price: 0,
        book_status: "1",
        ebook_status: "0",
        library_status: "0",
        description: "Lifetime membership to borrow books for four members of Family.",
        frequency: 3,
        slug: "golden",
        deleted_at: null,
        created_at: "2022-11-25T00:32:04.000000Z",
        updated_at: "2024-03-01T10:34:54.000000Z",
        num_books_borrow: null
    },
    {
        id: 3,
        name: "Lifetime membership",
        value: "Lifetime membership",
        price: 510,
        deposit: 0,
        renewal_price: 0,
        book_status: "1",
        ebook_status: "0",
        library_status: "0",
        description: "Lifetime membership to borrow books.",
        frequency: 3,
        slug: "golden",
        deleted_at: null,
        created_at: "2022-11-25T00:32:04.000000Z",
        updated_at: "2024-03-01T10:32:42.000000Z",
        num_books_borrow: null
    },
    {
        id: 4,
        name: "Library Access Of Study Room",
        value: "Library Access Of Study Room",
        price: 300,
        deposit: 0,
        renewal_price: 300,
        book_status: "0",
        ebook_status: "0",
        library_status: "1",
        description: "you can have access to the library for study.",
        frequency: 1,
        slug: "library-access-reading",
        deleted_at: null,
        created_at: "2024-02-22T07:34:56.000000Z",
        updated_at: "2024-03-01T10:31:51.000000Z",
        num_books_borrow: null
    },
    {
        id: 5,
        name: "E-LIBRARY ACCESS OF Computer",
        value: "E-LIBRARY ACCESS OF Computer",
        price: 500,
        deposit: 0,
        renewal_price: 500,
        book_status: "0",
        ebook_status: "1",
        library_status: "0",
        description: "to Access E-Books & Study on Computer",
        frequency: 1,
        slug: "e-book-access",
        deleted_at: null,
        created_at: "2024-02-22T07:35:33.000000Z",
        updated_at: "2024-03-01T10:29:55.000000Z",
        num_books_borrow: null
    },
    {
        id: 6,
        name: "Regular Membership",
        value: "Regular Membership",
        price: 130,
        deposit: 250,
        renewal_price: 130,
        book_status: "1",
        ebook_status: "0",
        library_status: "0",
        description: "Yearly membership to borrow books.",
        frequency: 2,
        slug: "silver",
        deleted_at: null,
        created_at: "2022-11-25T00:32:04.000000Z",
        updated_at: "2024-03-01T10:28:59.000000Z",
        num_books_borrow: null
    }
];
